// @flow
import React from 'react';
import {injectIntl} from 'react-intl';
import {compose} from 'redux';
import {connect} from 'react-redux';
import classNames from 'classnames';

import MetaTitle from './MetaTitle';
import MetaResultsCount from './MetaResultsCount';
import MetaMapButton from './MetaMapButton';
import SortLegalDisclaimer from '../SortLegalDisclaimer/SortLegalDisclaimer';
import DisclaimerMessaging from '../DisclaimerMessaging/DisclaimerMessaging';
import SortDropDown from '../SortDropDown/SortDropDown';

import './MetaTitleBar.less';

import type {State as ReduxState} from '../../reducers';
import type {Breakpoint} from '../../utils/breakpoints';
import type {IntlShape} from 'react-intl';
import type {SystemData} from '../../../server/utils/systemData';

type StateProps = {
    breakpoint: Breakpoint,
    hasSortLegalDisclaimer: boolean,
    orderBy: ?string,
    system: SystemData,
    isBoundingBoxSearch?: boolean
};
export type Shape = {
    resultsCount?: number,
    isLoadingOrRedirecting: boolean,
    geographyName: string
};

type InjectIntlProps = {
    intl: IntlShape
};

type Props = Shape & StateProps & InjectIntlProps;

export const MetaTitleBar = (props: Props) => {
    const {
        hasSortLegalDisclaimer,
        orderBy,
        intl,
        isBoundingBoxSearch,
        geographyName,
        isLoadingOrRedirecting,
        resultsCount,
        system,
        breakpoint
    } = props;
    const showSortLegalDisclaimer =
        hasSortLegalDisclaimer && (orderBy === 'default' || !orderBy);
    const classes = classNames('MetaTitleBar', {
        'MetaTitleBar--withlDisclaimer': showSortLegalDisclaimer,
        'MetaTitleBar--noResults': !resultsCount
    });

    return (
        <div className={classes} data-wdio="MetaTitleBar">
            {showSortLegalDisclaimer && (
                <SortLegalDisclaimer
                    intl={intl}
                    breakpoint={breakpoint}
                    system={system}
                />
            )}
            <div className="MetaTitleBar__content">
                <MetaTitle
                    isBoundingBoxSearch={isBoundingBoxSearch}
                    isLoadingOrRedirecting={isLoadingOrRedirecting}
                    geographyName={geographyName}
                />
                <div
                    id="resultsCountDisclaimerHeading"
                    className="MetaTitleBar__content__resultsCountWithDisclaimer"
                    role="heading"
                >
                    <MetaMapButton breakpoint={breakpoint} />
                    {!!resultsCount && (
                        <>
                            <MetaResultsCount
                                isLoadingOrRedirecting={isLoadingOrRedirecting}
                                resultCount={resultsCount}
                            />
                            <div className="sr-only">
                                <DisclaimerMessaging />
                            </div>
                            <SortDropDown />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

MetaTitleBar.defaultProps = {
    hasSortLegalDisclaimer: false,
    geographyName: '',
    isLoadingOrRedirecting: false
};

const mapStateToProps = (state: ReduxState): StateProps => {
    const {viewport, system, searchParams} = state;
    return {
        breakpoint: viewport.breakpoint,
        hasSortLegalDisclaimer: system.hasSortLegalDisclaimer,
        system,
        orderBy: searchParams.params.orderBy,
        isBoundingBoxSearch: searchParams.isBoundingBoxSearch
    };
};

export default compose(connect(mapStateToProps), injectIntl)(MetaTitleBar);
